import React, { useState } from 'react';
import { FaDonate, FaCopy, FaCheck, FaPhone, FaHandsHelping, FaInfo, FaInfoCircle, FaHeart, FaMoneyBillWave, FaShieldAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import PayPalButton from './PayPalButton';
const empowerment = require("../assets/1.jpeg")

const DonateNow = () => {
  // const [copied, setCopied] = useState<string | null>(null);

  // const copyToClipboard = (text: string, method: string) => {
  //   navigator.clipboard.writeText(text);
  //   setCopied(method);
  //   setTimeout(() => setCopied(null), 2000);
  // };

//   const donationMethods = [
    
//       {
//   name: "Remitly",
//   details: "+254 722 672323",
//   instructions: "Send support via Remitly to our verified number",
//   icon: <FaMoneyBillWave className="text-green-600" />, // More relevant icon
//   color: "bg-green-50", // Green for money/transactions
//   helperText: "Fast, secure transfers with low fees",
//   verificationBadge: (
//     <span className="flex items-center text-xs text-green-600 mt-1">
//       <FaShieldAlt className="mr-1" />
//       Verified Recipient
//     </span>
//   )
// }
    
//     // {
//     //   name: "Cash App",
//     //   details: "$2232548058",
//     //   instructions: "Send to this Cash App tag",
//     //   icon: <FaDonate className="text-green-500" />,
//     //   color: "bg-green-50"
//     // }
//   ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-3">Support Our Mission</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Your generosity enables us to continue spreading hope and serving communities
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
{/*             {donationMethods.map((method, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow"
            >
              <div className={`${method.color} p-6 flex items-center gap-4`}>
                <div className="p-3 bg-white rounded-full shadow-sm">
                  {method.icon}
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-800">{method.name}</h3>
                  {method.verificationBadge && (
                    <div className="mt-1">{method.verificationBadge}</div>
                  )}
                </div>
              </div>

              <div className="p-6">
                <p className="text-gray-600 mb-3">{method.instructions}</p>
                {method.helperText && (
                  <p className="text-sm text-gray-500 mb-5">{method.helperText}</p>
                )}

                <div className="flex items-center justify-between bg-gray-50 px-4 py-3 rounded-lg">
                  <code className="text-lg font-medium text-gray-800 break-all">
                    {method.details}
                  </code>
                  <button
                    onClick={() => copyToClipboard(method.details, method.name)}
                    className="ml-3 p-2 rounded-full hover:bg-gray-200 transition-colors"
                    aria-label={`Copy ${method.name} details`}
                  >
                    {copied === method.name ? (
                      <FaCheck className="text-green-500 text-lg" />
                    ) : (
                      <FaCopy className="text-gray-500 text-lg" />
                    )}
                  </button>
                </div>
              </div>
            </motion.div>
          ))} */}

          {/* Thank You Card with Local Image */}
          <div className="bg-white p-8 rounded-xl shadow-md max-w-md mx-auto">
            <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
              <FaHeart className="text-indigo-700 text-2xl" />
            </div>

            <h3 className="text-2xl font-bold text-indigo-700 mb-4 text-center">
              Paypal Available
            </h3>

            <p className="text-gray-600 mb-6 text-center leading-relaxed">
              Your generous donation helps us continue our vital work in the community.
              We've partnered with <span className="font-semibold">Father's Heart International Ministry (FHIM)</span>
              to ensure secure and transparent donation processing.
            </p>

            <div className="space-y-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <p className="text-sm text-blue-800 text-center">
                  <FaInfoCircle className="inline mr-2" />
                  100% of donations go directly to our programs
                </p>
              </div>

              <div className="w-full flex justify-center items-center text-center">
                <PayPalButton />
              </div>

              
            </div>
          </div>

          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow flex flex-col"
          >
            
            <div className="relative w-full overflow-hidden">
              <img
                src={empowerment}
                alt="Community appreciation"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>


          </motion.div> */}
        </div>
      </div>
    </section>
  );
};

export default DonateNow;
